import { RootState } from 'app/store';

import { createCombinedEvents } from 'utils/dateUtils';

export const selectInterviewSlots = (state: RootState) =>
  state.interviewSlots.slots;

export const selectInterviewSlotsApplicationId = (state: RootState) =>
  state.interviewSlots.applicationId;

export const selectInterviewSlotsLoading = (state: RootState) =>
  state.interviewSlots.isLoading;

export const selectInterviewSlotsError = (state: RootState) =>
  state.interviewSlots.error;

export const selectInterviewSlotsCount = (state: RootState) =>
  state.interviewSlots.slots.length;

export const selectProposedSlots = (state: RootState) =>
  state.interviewSlots.proposedSlots;

export const selectSelectedSlot = (state: RootState) =>
  state.interviewSlots.selectedSlot;

export const selectProposedSlotsCount = (state: RootState) =>
  state.interviewSlots.proposedSlots.length;

// Select combined events for calendar
export const selectCombinedEvents = (state: RootState) =>
  createCombinedEvents(
    selectInterviewSlots(state),
    selectProposedSlots(state),
    selectSelectedSlot(state)
  );
